import { post, upload, uploadSplice, responseData } from '@/utils/network';
import { UploadFileIF } from '@/interfaces/types';
import { UserInfo } from "@/interfaces/vuexStateInterface";

export function getUserInfo(parm?:any) {
  return post<UserInfo>('/UserApi/getUserInfo',parm);
}

export function uploadFile(file: any) {
  return upload<UploadFileIF>('UploadApi/uploadV2', file);
}

export function uploadFileSplice(file: FormData) {
  return uploadSplice<UploadFileIF | {isChunk:boolean, chunk: string}>('UploadApi/uploadV2', file)
}

export function getAttachmentInfo(fileId: string,) {
  return post<{info: UploadFileIF}>('/FileApi/getAttachmentInfo', {
    id: fileId,
  })
}

export function getFilePreviewUrl(fileid: string) {
  return post<{ rurl: string }>('/ResourceTopicApi/getFilePreviewUrl', { fileid })
}

export interface attachment {
  fileid: string;
  ext: string;
  ext_s: string;
  ext_type: string;
  size: string;
  name: string;
  url: string;
  date: string;
  rurl: string;
  annotator: string;
}

export function getCommentPage({ contentid, contenttype, page, limit, id }: { contentid: string; contenttype: string; page: string; limit: string; id: string }) {
  return post<{
    list: Array<{
      id: string;
      contentid: string;
      contenttype: string;
      attachment: Array<attachment>;
      content: string;
      replyid: string;
      anonymous: string;
      createtime: string;
      is_likes: string;
      likes: string;
      first_depth_id: string;
      userinfo: {
        username: string;
        avatar: string;
      };
      childen: Array<{
        id: string;
        contentid: string;
        contenttype: string;
        attachment: Array<attachment>;
        content: string;
        replyid: string;
        anonymous: string;
        createtime: string;
        is_likes: string;
        likes: string;
        first_depth_id: string;
        username: string;
        avatar: string;
      }>;
    }>;
  }>('/Futurev2/Comment/getCommentPage', { contentid, contenttype, page, limit, id });
}
export function getCourseQuestions({courseid, contentid, contenttype, page, limit,start_time ,end_time }: {courseid:string, contentid: string; contenttype: string; page: string; limit: string; start_time: string,end_time:string }) {
  return post<{
    list: Array<{
      id: string;
      contentid: string;
      contenttype: string;
      attachment: Array<attachment>;
      content: string;
      replyid: string;
      anonymous: string;
      createtime: string;
      is_likes: string;
      likes: string;
      first_depth_id: string;
      userinfo: {
        username: string;
        avatar: string;
      };
      childen: Array<{
        id: string;
        contentid: string;
        contenttype: string;
        attachment: Array<attachment>;
        content: string;
        replyid: string;
        anonymous: string;
        createtime: string;
        is_likes: string;
        likes: string;
        first_depth_id: string;
        username: string;
        avatar: string;
      }>;
    }>;
  }>('/Futurev2/CourseQuestions/lists', {courseid, contentid, contenttype, page, limit,start_time ,end_time });
}
export function addComment(arg: {
  content: string;
  courseid: string;
  contentid: string;
  contenttype: string;
  replyid: string;
  anonymous: string;
  attachment: string;
  firstdepthid: string;
  id: string;
}) {
  return post('/Futurev2/Comment/addComment', arg);
}
export function CreateQuestions(arg: {
  content: string;
  courseid: string;
  contentid: string;
  contenttype: string;
  point:string;
  attachment:any;
  parentid:string;
  first_depth_id:string;
}) {
  return post('/Futurev2/CourseQuestions/create', arg);
}
export function setCommentlike(id: string) {
  return post('/Futurev2/Comment/like', { id });
}

export function delComment(id: string, courseid: string) {
  return post('/Futurev2/Comment/delComment', { id, courseid });
}

// 获取微信配置
export function postGetWechatConfig() {
  return post('/UserApi/getWechatThirdPardLoginConf');
}

// 判断某个类型是否被引导过 新版
export function isTourV2(version: string, courseid: string) {
  return post<{isTour: number; status: number; info: string}>('TourApi/isTourV2', { version, courseid });
}

// 设置某个页面的引导已经完成
export function setTourFinishV2(version: string, courseid: string) {
  return post('TourApi/setTourFinishV2', { version, courseid});
}

